export function getHasListingPublicationActionsMenu({
  isMenuDisabled,
  options,
}) {
  return options.length > 0 || Boolean(isMenuDisabled)
}
